module.exports = __webpack_public_path__ + "img/section5-bg.eab1e75e.jpg";